import { appEnv } from "@/common/AppConst";
import { RequestUtils } from "@/common/RequestUtils";
import { UrlPath } from "@/request";
import { RootStore } from "@/vuex-store";

function sendPayForm(payPkgId: number, returnUrl: string) {
    const accessToken = RootStore.state.currUser?.accessToken;
    const url = appEnv.apiBaseUrl + UrlPath.aliPayForPage;
    RequestUtils.sendForm(url, { payPkgId, returnUrl, accessToken });
}

export const AliPayApi = {
    sendPayForm,
};
